import React from "react";
import { ArrowLeftOutlined, ArrowRightOutlined, WarningOutlined } from "@ant-design/icons";
import styles from "./SwmsWizard.module.css";

const METHODS_BY_CAT = {
  "rope-access": [
    "Anchor Point Inspection & Setup",
    "Rope System Configuration",
    "Fall Arrest Procedures",
    "Communication Protocol (Height)",
    "Emergency Descent & Rescue",
    "PPE Requirements (Rope Access)"
  ],
  "ewp": [
    "Pre-Operational Inspection",
    "Ground Stability Assessment",
    "Overhead Hazard Clearance",
    "Operator Certification Check",
    "Exclusion Zone Setup (EWP)",
    "Emergency Lowering Procedure"
  ],
  "scaffolding": [
    "Scaffold Erection & Inspection",
    "Handrail & Toeboard Installation",
    "Load Capacity Assessment",
    "Access & Egress Points",
    "Scaffold Tag & Sign-off Process",
    "Adverse Weather Protocol"
  ],
  "ladder": [
    "Ladder Inspection Pre-Use",
    "Secure Footing & Positioning",
    "3-Point of Contact Rule",
    "Maximum Height Restrictions",
    "Securing Top of Ladder",
    "Working from Ladder Constraints"
  ],
  "ground": [
    "Work Area Demarcation",
    "Slip & Trip Hazard Management",
    "Chemical Storage & Handling",
    "Wet Work Protocol",
    "Pedestrian Exclusion Zone",
    "Manual Handling Controls"
  ],
  "confined": [
    "Entry Permit Procedure",
    "Atmospheric Testing",
    "Ventilation Requirements",
    "Standby Person Duties",
    "Emergency Rescue Plan",
    "Communication Procedures (Confined)"
  ]
};

const CAT_LABELS = {
  "rope-access": "Rope Access",
  "ewp": "EWP",
  "scaffolding": "Scaffolding",
  "ladder": "Ladder Work",
  "ground": "Ground Level",
  "confined": "Confined Space"
};

export default function SwmsWizardStep2({
  selectedCategories,
  selectedMethods,
  showValidation,
  onToggleMethod,
  onContinue,
  onBack
}) {
  return (
    <div className={styles.stepBody}>
      {/* Selected categories summary */}
      <div className={styles.catSummaryRow}>
        {selectedCategories.map((catId) => {
          const catLabel = CAT_LABELS[catId];
          return (
            <span key={catId} className={styles.catSummaryTag}>
              {catLabel}
            </span>
          );
        })}
      </div>

      <h1 className={styles.stepTitle}>Step 2: Select Work Methods</h1>
      <p className={styles.stepSubtitle}>Select the specific work methods and hazard controls for your chosen categories.</p>

      <div className={styles.methodsContainer}>
        {selectedCategories.map((catId) => {
          const catLabel = CAT_LABELS[catId];
          const methods = METHODS_BY_CAT[catId];
          return (
            <div key={catId} className={styles.methodSection}>
              <div className={styles.methodSectionHeader}>
                <span className={styles.methodSectionTag}>{catLabel}</span>
                <span className={styles.methodSectionHint}>Select applicable methods</span>
              </div>
              <div className={styles.methodGrid}>
                {methods.map((method) => {
                  const isMethodSelected = selectedMethods.includes(method);
                  const methodCardClass = isMethodSelected
                    ? `${styles.methodCard} ${styles.selected}`
                    : styles.methodCard;
                  return (
                    <div
                      key={method}
                      className={methodCardClass}
                      onClick={() => onToggleMethod(method)}
                    >
                      <input
                        type="checkbox"
                        className={styles.methodCheckbox}
                        checked={isMethodSelected}
                        onChange={() => onToggleMethod(method)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <span className={styles.methodLabel}>{method}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      {showValidation && (
        <div className={styles.validationMsg}>
          <WarningOutlined />
          Please select at least one work method to continue.
        </div>
      )}

      <div className={styles.stepFooterBetween}>
        <button className={styles.backButton} onClick={onBack}>
          <ArrowLeftOutlined />
          Back to Categories
        </button>
        <button className={styles.continueButton} onClick={onContinue}>
          Continue to QLIs
          <ArrowRightOutlined />
        </button>
      </div>
    </div>
  );
}
